module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.272 2.174L29.824.726a2.475 2.475 0 0 0-3.502 0l-2.573 2.576L28.7 8.253l2.573-2.574a2.477 2.477 0 0 0 0-3.504zM10.288 26.661l-4.949-4.95L21.275 5.775l4.95 4.949L10.289 26.66zM.081 31.268c-.236.594.055.885.649.649l7.106-2.807-4.948-4.948-2.807 7.106z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pencil-1.js
// module id = 1339
// module chunks = 14